/* COMPONENT IMPORTS*/
import MGModalityHeader from "../../components/MGModalityHeader/MGModalityHeader";
import MGMyModalities from "../../components/MGMyModalities/MGMyModalities";
import MGModalitySubscription from "../../components/MGModalityCardsSubscription/MGModalitySubscription";

import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";

import ContextConstructor from "../../components/Context/Context";

import React, { Component } from "react";

/* SAME FOLDER IMPORTS*/
import { MGModalityStep } from "../../utils/MGModalityStep";
import MGMySubscriptions from "../../components/MGMySubscriptions/MGMySubscriptions";
import { MGMySubscriptionDetailCardType } from "../../components/MGMySubscriptions/MGMySubscriptionDetailCardType";
import { getPublicURL } from "../../env";


import sendLogError from "../../sendLogError";

/* CSS IMPORT */
import "./Protecao.css";
import "../../components/Loading/loading.css";

//Imagem
import loading from "../../images/loading.svg";
import { ArrowLeft } from 'lucide-react';
import protecao from "../../images/Modality/protecao.svg"

var reactPlugin = new ReactPlugin();

class Protecao extends Component {
  static displayName = Protecao.name;

  constructor(props) {
    super(props);
    this.state = {
      protecao: [],
      error: [],
      loading: true,
      step: MGModalityStep.DASHBOARD,
      item: ""
    };
  }

  componentDidMount() {
    if (
      this.context.selectedUserID !== "" &&
      this.context.selectedUserID !== undefined &&
      this.context.selectedUserID !== null
    ) {
      this.populateProtectionData();
    }
  }

  errorLoadingPortfolio() {
    return (
      <div>
        <ErrorPage />
      </div>
    );
  }

  handleBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.history.replaceState(null, "", "/");
    }
  }

  transformActives(a) {
    if (a == "1") return a + " subscrição ativa";
    else return a + " subscrições ativas";
  }

  renderProtectionData(state) {
    return (
      <div>
        <main className="Protecao-main">
          <MGModalityHeader
            subscriptionActivity={this.transformActives(state.protecao.subscriptionsNumber)}
            icon={protecao}
            title={'Proteção'}
            leftTitle={"Capital Subscrito"}
            leftAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(state.protecao.totalAmounts.totalCurrentAmount)}
            rightTitle={"Entrega periódica"}
            rightAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(state.protecao.totalAmounts.totalPaidAmount)} />
          <MGMyModalities
            myModalities={state.protecao}
            leftTitle={"Capital Subscrito"}
            rightTitle={"Entrega periódica"}
            onClick={(key) => {
              this.setState({ step: MGModalityStep.DETAIL, item: key })
            }}
          />
          <MGModalitySubscription id={"2"} context={this.context} myModalities={state.protecao.productTypes} publicURL={getPublicURL()} />
        </main>
      </div>
    );
  }

  renderProtectionDetail(state) {
    const { productName, subscriptionsNumber, totalAmounts, subscriptions } = this.filterProtectionList(state);
    return (
      <div>
        <header className="Savings-header">
          <ArrowLeft onClick={() => { this.setState({ step: MGModalityStep.DASHBOARD, item: "" }) }} />
          Voltar a Proteção
        </header>
        <main className="Savings-main">
          <MGModalityHeader
            subscriptionActivity={this.transformActives(subscriptionsNumber)}
            icon={protecao}
            title={productName}
            leftTitle={"Capital Subscrito"}
            leftAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(totalAmounts.totalCurrentAmount)}
            rightTitle={"Entrega periódica"}
            rightAmount={new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(totalAmounts.totalPaidAmount)} />

          <MGMySubscriptions mySubscriptions={subscriptions} subscriptionDetailCardType={MGMySubscriptionDetailCardType.PROTECTION} />
        </main>
      </div>
    );
  }

  filterProtectionList(state) {
    return state.protecao.productTypes.find((i) => (i.productID === state.item))
  }

  renderPage(state) {
    switch (state.step) {
      case MGModalityStep.DASHBOARD:
        return this.renderProtectionData(this.state)
      case MGModalityStep.DETAIL:
        return this.renderProtectionDetail(state);
      default:
        return this.renderPortfolioData(state);
    }
  }


  render() {
    let contents = this.state.loading ? (
      <div className="main-page-loading">
        <div className="loading">
          <img src={loading}></img>
        </div>
      </div>
    ) : this.state.error ? (
      this.errorLoadingPortfolio()
    ) : (
      <div className="main">
        {this.renderPage(this.state)}
      </div>
    );

    return <>{contents}</>;
  }

  async populateProtectionData() {
    try {
      const { idToken, selectedUserID } = this.context;

      const headers = {
        Authorization: `Bearer ${idToken}`,
        clientId: selectedUserID,
      };

      const response = await fetch("/Portfolio/GetPortfolio", { headers });

      if (!response.ok) {
        this.setState({
          error: false,
          protecao: {},
          loading: false,
        });

        return;
      }

      const data = await response.json();

      this.setState({
        error: false,
        protecao: data?.protection || {},
        loading: false,
      });

    } catch (error) {
      console.error("Error fetching protection data:", error);

      this.setState({
        error: true,
        loading: false,
        protecao: {},
      });

      sendLogError(error.message, "populateProtectionData");
    }
  }
}

Protecao.contextType = ContextConstructor;

export default withAITracking(reactPlugin, Protecao);
